import { useEffect, useState, ReactNode } from 'react';
import Header from '../header';
import { LeftMenu } from '../left-menu';
import styles from './index.module.css';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // scroll to top on route change
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  const onMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className={styles.wrapper}>
      <LeftMenu isMenuOpen={isMenuOpen} onMenuToggle={onMenuToggle} />
      <div className={styles.contentWrapper}>
        <Header onMenuToggle={onMenuToggle} />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
